import React, { useEffect, useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { getValueFromResource } from '../../../common/timeLiveFunction'
import { useAppDispatch } from '../../../app/hooks'
import { t } from "i18next"

const BoardTeamMember = (props: any) => {
    const { AccountProjectId, team, onSelectedMember, isAddingTask = false, resetTrigger, isOpen } = props
    const dispatch = useAppDispatch()
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [localTeam, setLocalTeam] = useState<any[]>([]);

    useEffect(() => {
        setLocalTeam(team ? [...team].sort((a, b) => (b.IncludeTeam ? 1 : 0) - (a.IncludeTeam ? 1 : 0)) : []);
    }, [team]);

    useEffect(() => {
    if (!isOpen) {
        setSearchTerm('');
    }
}, [isOpen]);
    // const filteredTeam = team?.filter((member: any) => member.Name?.toLowerCase().includes(searchTerm.toLowerCase())).sort((a: any, b: any) => (b.IncludeTeam ? 1 : 0) - (a.IncludeTeam ? 1 : 0))
    useEffect(() => {
        if (resetTrigger === null || resetTrigger === undefined) {
            setSelectedIds([])
            setSearchTerm('')
        }
    }, [resetTrigger])

    const filteredTeam = localTeam?.filter((member: any) => (member.EmployeeName || member.Name)?.toLowerCase().includes(searchTerm.toLowerCase())).sort((a: any, b: any) => (b.IncludeTeam ? 1 : 0) - (a.IncludeTeam ? 1 : 0))

    const handleMemberToggle = (member: any) => {
        if (isAddingTask) {
            const alreadySelected = selectedIds.includes(member.AccountEmployeeId)
            let updatedIds = []

            if (alreadySelected) {
                updatedIds = selectedIds.filter(id => id !== member.AccountEmployeeId)
            } else {
                updatedIds = [...selectedIds, member.AccountEmployeeId]
            }
            setSelectedIds(updatedIds)
            if (onSelectedMember) {
                onSelectedMember(updatedIds)
            }
        } else {
            const updatedMember = {
                ...member,
                IncludeTeam: !member.IncludeTeam,
            }
            setLocalTeam(prev => prev.map(m => m.AccountEmployeeId === member.AccountEmployeeId ? updatedMember : m));
            if (onSelectedMember) {
                onSelectedMember(updatedMember)
            }
        }
    }

    return (
        <div>
            {/* <Dropdown.Menu
                className="menu menu-sub menu-sub-dropdown menu-column px-2 py-2 fs-7 w-200px"
                onClick={(e) => e.stopPropagation()}
                popperConfig={{
                    strategy: 'fixed',
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'viewport',
                                padding: 8,
                            },
                        },
                    ],
                }}
            > */}

            <Dropdown.Header>
                <div className="position-relative">
                    <input
                        type="text"
                        placeholder={getValueFromResource('Search', dispatch, t)}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="form-control h-35px w-170px fs-7 fw-normal"
                        data-kt-user-table-filter="search"
                    />
                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0 searchIconRight">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </div>
            </Dropdown.Header>

            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {filteredTeam?.map((member: any, i: number) => (
                    <React.Fragment key={i}>
                        <Dropdown.Item className="d-flex align-items-center gap-2 py-1" onClick={() => handleMemberToggle(member)} >
                            <Form.Check
                                type="checkbox"
                                checked={isAddingTask ? selectedIds.includes(member.AccountEmployeeId) : member.IncludeTeam}
                                onChange={() => handleMemberToggle(member)}
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                    transform: 'scale(0.6)',
                                    marginRight: '4px',
                                }}
                            />
                            <div

                                className="symbol-label text-white fw-bold d-flex align-items-center justify-content-center"
                                style={{
                                    backgroundColor: member.ProfilePictureColor || '#512DA8',
                                    borderRadius: '50%',
                                    width: '26px',
                                    height: '26px',
                                    fontSize: '11px',
                                    flexShrink: 0,
                                }}
                            >
                                {member.ShortName}
                            </div>
                            <span className="text-gray-800 fw-semibold">{member.Name}</span>
                        </Dropdown.Item>
                        <div className="separator mb-1 mt-1 opacity-75"></div>
                    </React.Fragment>
                ))}
            </div>
            {/* </Dropdown.Menu> */}
        </div>
    )
}

export default BoardTeamMember
